type PosthogLike = {
  identify: (userId: string, properties?: Record<string, unknown>) => void;
  reset: () => void;
};

const getPosthog = (): PosthogLike | null => {
  if (typeof window === "undefined") return null;

  const posthog = (window as Window & { posthog?: PosthogLike }).posthog;
  if (!posthog) return null;

  return posthog;
};

export const identifyPosthogUser = (
  userId: string,
  properties?: Record<string, unknown>,
) => {
  const posthog = getPosthog();
  if (!posthog) return;

  posthog.identify(userId, properties);
};

export const resetPosthogUser = () => {
  const posthog = getPosthog();
  if (!posthog) return;

  posthog.reset();
};
